import _ from 'lodash';
import React from 'react';
import keycode from 'keycode';

import ensureArray from './ensureArray';

type KeyboardEventType = React.KeyboardEvent<EventTarget>;

// use this function in conjunction with any key event to create handlers for specific keys.
const createKeyHandler = (
  keys: string | Array<string>,
  onKey: (e: KeyboardEventType) => any
) => (e: KeyboardEventType) => {
  const keysArray = ensureArray(keys);

  const hasAnyMatchingKeys = _.some(
    keysArray,
    (key: string) => e.keyCode === Number(keycode(key))
  );

  if (hasAnyMatchingKeys) {
    onKey(e);
  }
};

export default createKeyHandler;
